import { render, staticRenderFns } from "./PaymentLoading.vue?vue&type=template&id=7af561a2&scoped=true"
import script from "./PaymentLoading.vue?vue&type=script&lang=ts"
export * from "./PaymentLoading.vue?vue&type=script&lang=ts"
import style0 from "./PaymentLoading.vue?vue&type=style&index=0&id=7af561a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af561a2",
  null
  
)

export default component.exports